export const campaignEn = {
  campaign: {
    title: 'Email Campaigns',
    subtitle: 'Create, manage and track your campaigns',
    new: 'New Campaign',
    // Status
    statusDraft: 'Draft',
    statusScheduled: 'Scheduled',
    statusSending: 'Sending',
    statusSent: 'Sent',
    statusPaused: 'Paused',
    statusCancelled: 'Cancelled',
    // Type
    typeEmail: 'Email',
    typeSms: 'SMS',
    // List
    name: 'Campaign Name',
    type: 'Type',
    status: 'Status',
    recipients: 'Recipients',
    createdAt: 'Created',
    sentAt: 'Sent',
    actions: 'Actions',
    noCampaigns: 'No campaigns yet. Create your first one!',
    // Builder
    builderTitle: 'Create Campaign',
    stepDetails: 'Details',
    stepAudience: 'Audience',
    stepContent: 'Content',
    stepSchedule: 'Schedule',
    stepReview: 'Review',
    // Details step
    campaignName: 'Campaign Name',
    campaignNamePlaceholder: 'e.g. Winter Promotion',
    campaignType: 'Campaign Type',
    // Audience step
    audienceType: 'Audience Type',
    audienceAll: 'All Customers',
    audienceGroup: 'Customer Group',
    audienceFiltered: 'Filtered Customers',
    audienceManual: 'Manual Selection',
    selectGroups: 'Select Groups',
    estimatedRecipients: 'Estimated Recipients',
    // Content step
    subject: 'Subject',
    subjectPlaceholder: 'Email subject',
    preheader: 'Preheader',
    preheaderPlaceholder: 'Short summary...',
    body: 'Email Body',
    bodyPlaceholder: 'Write your email content...',
    fromName: 'From Name',
    replyTo: 'Reply To',
    templateSelect: 'Select Template',
    noTemplate: 'No template',
    // Schedule step
    sendNow: 'Send Now',
    scheduleLater: 'Schedule for Later',
    scheduledAt: 'Send Date & Time',
    timezone: 'Timezone',
    // Review step
    reviewTitle: 'Campaign Review',
    reviewName: 'Name',
    reviewType: 'Type',
    reviewAudience: 'Audience',
    reviewContent: 'Content',
    reviewSchedule: 'Schedule',
    // Actions
    save: 'Save',
    saveDraft: 'Save as Draft',
    send: 'Send',
    cancel: 'Cancel',
    back: 'Back',
    next: 'Next',
    edit: 'Edit',
    delete: 'Delete',
    duplicate: 'Duplicate',
    // Stats
    statsTitle: 'Statistics',
    statsTotal: 'Total Recipients',
    statsSent: 'Sent',
    statsDelivered: 'Delivered',
    statsOpened: 'Opened',
    statsClicked: 'Clicked',
    statsBounced: 'Bounced',
    statsFailed: 'Failed',
    statsUnsubscribed: 'Unsubscribed',
    openRate: 'Open Rate',
    clickRate: 'Click Rate',
    deliveryRate: 'Delivery Rate',
    // Messages
    createSuccess: 'Campaign created successfully',
    createError: 'Error creating campaign',
    deleteConfirm: 'Are you sure you want to delete this campaign?',
    deleteWarning: 'This action cannot be undone.',
    sendConfirm: 'Are you sure you want to start this campaign?',
    sendWarning: 'Once started, the content cannot be modified.',
  },
};
